const DESIGN_STUDIO_PATH = /^\/workspaces\/[^/]+\/design-studio(\/|$)/;

/**
 * True for the Design Studio pages in a workspace: the dashboard, global styles and the editor
 * routes. The `design-studio-embed` routes live outside `/workspaces/:id` and do not match.
 */
export const isDesignStudioPath = (pathname: string) => DESIGN_STUDIO_PATH.test(pathname);
